// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import CloseCircleFilledSvg from "@ant-design/icons-svg/lib/asn/CloseCircleFilled";
import AntdIcon from "../components/AntdIcon";
const CloseCircleFilled = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: CloseCircleFilledSvg
    });
if (process.env.NODE_ENV !== "production") {
    CloseCircleFilled.displayName = "CloseCircleFilled";
}
export default /*#__PURE__*/ React.forwardRef(CloseCircleFilled);
